const NAMESPACE = "importNewRowsDialog";

const KEYS = {
    uploadFileLabel: "uploadFileLabel",
    unableToImportAlertHeader: "unableToImportAlertHeader",
    warningAlertHeader: "warningAlertHeader",
    tablePreviewLabel: "tablePreviewLabel",
    missingRequiredValueMessage: "missingRequiredValueMessage",
    tooManyRowsError: "tooManyRowsError",
    resolutionTooSmallWarning: "resolutionTooSmallWarning"
};

const MESSAGES = {
    [KEYS.uploadFileLabel]: {
        value: "Upload CSV File",
        comment: "Label for the upload csv file element"
    },
    [KEYS.unableToImportAlertHeader]: {
        value: "Unable to import file",
        comment: "Error header when unable to upload a file"
    },
    [KEYS.warningAlertHeader]: {
        value: "Warning",
        comment: "Header for any warnings from the uploaded file"
    },
    [KEYS.tablePreviewLabel]: {
        value: "Table Preview",
        comment: "Label for the table preview"
    },
    [KEYS.missingRequiredValueMessage]: {
        value: "Missing required value(s) in column {headerName}",
        comment: "Error when a column is missing a required value"
    },
    [KEYS.tooManyRowsError]: {
        value: "There are too many rows in the imported file",
        comment: "Error message when the imported file contains too many rows"
    },
    [KEYS.resolutionTooSmallWarning]: {
        value:
            "Screen resolution may be too small to properly display the imported table." +
            " It is best to use large screens when previewing a table",
        comment: "Warning message when the user's screen resolution is too small to properly display the table"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
